import React from "react";
import "../../styles/components/RelatioHero.css";

import chatshopPhone from "../../img/cases/chatshop-phone-2.webp";
import cloudsImage from "../../img/cases/case-clouds-2.webp";
import chatshopLogo from "../../img/cases/chatshop-logo.png";

export default function ChatshopHero() {
    return (
        <section className="relatio-hero relatio-hero--chatshop relatio-hero-anim">
            <div className="relatio-hero__content relatio-hero-anim__content">
                <h1 className="relatio-hero__title">
                    Conversational <strong>AI Storefront</strong>
                    <br />
                    Built to Convert
                </h1>

                <p className="relatio-hero__text">
                    An AI shopping assistant that replaces catalog browsing with natural
                    conversation — understanding what users want even from vague requests
                    like "something dark to pair with meat."
                </p>

                <div className="relatio-hero__chips">
                    <span>GPT-4o-mini</span>
                    <span>PostgreSQL</span>
                    <span>Node.js/Express</span>
                    <span>React</span>
                    <span>Firebase</span>
                    <span>Amplitude</span>
                </div>
            </div>

            <div className="relatio-hero__glass relatio-hero__glass--client relatio-hero-anim__glass-1">
                <span>Client</span>
                <img
                    className="relatio-hero__logo relatio-hero__logo--chatshop"
                    src={chatshopLogo}
                    alt="Chatshop"
                />
            </div>

            <div className="relatio-hero__glass relatio-hero__glass--industry relatio-hero-anim__glass-2">
                <span>Industry</span>
                <strong>AI E-COMMERCE</strong>
            </div>

            <img
                className="relatio-hero__clouds relatio-hero-anim__clouds"
                src={cloudsImage}
                alt=""
                aria-hidden="true"
            />

            <img
                className="relatio-hero__phone relatio-hero__phone--chatshop relatio-hero-anim__phone"
                src={chatshopPhone}
                alt="Chatshop app"
            />
        </section>
    );
}
